// noinspection JSUnusedGlobalSymbols
export enum CallEvent {
  IncomingCall = 'IncomingCall',
  CallAccepted = 'CallAccepted',
  CallCancelled = 'CallCancelled',
  CallUpdated = 'CallUpdated',
  CallEnded = 'CallEnded',
  TaskTerminated = 'TaskTerminated',
}
